import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateCommentMutation,
  UpdateCommentMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../useGraphQlClient";

const updateComment = graphql(`
  mutation updateComment($request: UpdateCommentRequest!) {
    updateComment(UpdateCommentRequest: $request) {
      id
      content
      companyId
      objectId
      createdAt
      updatedAt
    }
  }
`);

export function useUpdateComment(
  options?: UseMutationOptions<
    UpdateCommentMutation,
    unknown,
    UpdateCommentMutationVariables,
    unknown
  >,
) {
  const { logEvent } = useTracking();
  const { data, ...rest } = useGraphQlMutation(updateComment, {
    ...options,
    onSuccess: (data, vars, context) => {
      logEvent(EventNames.commentActioned, {
        "Action type": "edited",
        "Comment ID": data.updateComment?.id,
      });
      options?.onSuccess?.(data, vars, context);
    },
  });

  return { data: data?.updateComment, ...rest };
}
